// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__83zUh","clinicsSelect":"styles_clinicsSelect__lomqX"};